export default {
  index: 'Índice',
  classPlanDescription: 'Plan de clases',
  media: 'Disparador',
  pedagogicalGoal: 'Objetivo pedagógico',
  studentPedagogicalGoal: 'Objetivo pedagógico',
  trigger: 'Punto de partida',
  organization: 'Organización',
  statement: 'Consigna',
  class: 'Clase',
  startSection: 'Inicio',
  developmentSection: 'Desarrollo',
  closureSection: 'Cierre',
  necessaryMaterials: 'Vas a necesitar',
  valuationSection: 'Sugerencias de evaluación',
  globalValuation: 'Sugerencias de evaluación del recurso',
  studentPreview: 'Vista previa del estudiante',
  necessaryDownloadableMaterials: 'Contenido descargable',
  rhetoricalQuestion: 'Pregunta disparadora'
}

export const en = {
  index: 'Índice',
  classPlanDescription: 'Lesson plan',
  media: 'Trigger',
  pedagogicalGoal: 'Resource objectives',
  studentPedagogicalGoal: 'Resource objectives',
  trigger: 'Starting point',
  organization: 'Organization',
  statement: 'Assignment',
  class: 'Class',
  startSection: 'Start',
  developmentSection: 'Development',
  closureSection: 'Closure',
  necessaryMaterials: 'You\'ll need',
  valuationSection: 'Assessment suggestions',
  globalValuation: 'Suggested resource evaluation',
  studentPreview: 'Student\'s preview',
  necessaryDownloadableMaterials: 'Downloadable content',
  rhetoricalQuestion: 'Triggering question'
}

export const ca = {
  index: 'Índice',
  classPlanDescription: 'Pla de classes',
  media: 'Disparador',
  pedagogicalGoal: 'Objectiu del recurs',
  studentPedagogicalGoal: 'Objectiu del recurs',
  trigger: 'Punt de partida',
  organization: 'Organització',
  statement: 'Consigna',
  class: 'Classe',
  startSection: 'Inici',
  developmentSection: 'Desenvolupament',
  closureSection: 'Tancament',
  necessaryMaterials: 'Necessitaràs',
  valuationSection: 'Suggeriments d\'avaluació',
  globalValuation: 'Suggeriments d\'avaluació del recurs',
  studentPreview: 'Vista prèvia de l\'estudiant',
  necessaryDownloadableMaterials: 'Contingut descarregable',
  rhetoricalQuestion: 'Pregunta disparadora'
}
